import { render, staticRenderFns } from "./yishenpiList.vue?vue&type=template&id=95235eae&scoped=true&"
import script from "./yishenpiList.vue?vue&type=script&lang=js&"
export * from "./yishenpiList.vue?vue&type=script&lang=js&"
import style0 from "./yishenpiList.vue?vue&type=style&index=0&id=95235eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95235eae",
  null
  
)

export default component.exports